import React from "react";

import {
  Flex,
  Button,
  FormControl,
  Input,
  useColorModeValue,
  useColorMode,
} from "@chakra-ui/react";

import routes from "../../routes";

import Sidebar from "../../Components/Sidebar";
import Prospects from "../Prospects";

const ProspectsLayout = () => {
  return (
    <Flex direction="row" position="relative" w="100%" h="100vh">
      <Sidebar routes={routes} />
      <Prospects />
    </Flex>
  );
};

export default ProspectsLayout;
